import $ from 'jquery';
import { sendCartDrawerOpenRequestEvent } from '../core/notifications/cart-drawer-open-request';
import { SingleItemPayload } from '../core/cart/machine/context/add-items-to-cart/payload';
import { getCartMachine } from '../core/cart';
const refreshATCButton = ()=>{
    const quantities = $('.js-upsell-quantity');
    const allEmptyQuantities = quantities.get().every((el)=>el.getAttribute('value') === '0');
    if (allEmptyQuantities) {
        $('.js-upsell-button').attr('disabled', '');
        return;
    }
    $('.js-upsell-button').attr('disabled', null);
};
const changeSwatch = ()=>{
    $('.js-upsell-color').on('click', function(ev) {
        const container = $(ev.currentTarget).parents('.js-upsell-color-item');
        // get variant id
        const variantId = $(this).attr('variant_id');
        const variantColor = $(this).attr('color') || '';
        const quantityText = container.find('.js-upsell-quantity-number');
        const quantity = container.find(`.js-upsell-quantity[variant_id='${variantId}']`).val();
        // change color swatch
        container.find('.js-upsell-color').removeClass('--is-active');
        container.find(`.js-upsell-color[variant_id='${variantId}']`).addClass('--is-active');
        // change price
        container.find('.js-upsell-price').removeClass('--is-active');
        container.find(`.js-upsell-price[variant_id='${variantId}']`).addClass('--is-active');
        // change image
        container.find('.js-upsell-image').removeClass('--is-active');
        container.find(`.js-upsell-image[variant_id='${variantId}']`).addClass('--is-active');
        container.find('.js-upsell-color-label span').text(variantColor);
        quantityText.text((quantity === null || quantity === void 0 ? void 0 : quantity.toString()) || '0');
    });
};
const changeQuantity = ()=>{
    $('.js-upsell-quantity-minus, .js-upsell-quantity-plus').on('click', (ev)=>{
        const button = $(ev.currentTarget);
        const container = button.parents('.js-upsell-color-item');
        const quantityText = container.find('.js-upsell-quantity-number');
        const activeVariant = container.find('.js-upsell-color.--is-active').attr('variant_id');
        const quantityInput = container.find(`.js-upsell-quantity[variant_id=${activeVariant}]`);
        const quantity = Number(quantityInput.val());
        const action = button.data('action') === 'plus' ? 'plus' : 'minus';
        if (quantity === 0 && action === 'minus') {
            return;
        }
        const newQuantity = action === 'minus' ? quantity - 1 : quantity + 1;
        quantityInput.val(newQuantity);
        quantityText.text(newQuantity);
        refreshATCButton();
    });
};
export const init = async function() {
    changeSwatch();
    changeQuantity();
    // add to cart
    $(document).on('click', '.js-upsell-button', (ev)=>{
        ev.preventDefault();
        const container = $(ev.currentTarget).parents('.js-upsell');
        const items = container.find('.js-upsell-quantity');
        const isCartPage = $('body').attr('data-shopify-template') === 'cart';
        const data = [];
        items.each((_, item)=>{
            const id = $(item).attr('variant_id');
            const quantity = $(item).val();
            data.push(SingleItemPayload.create({
                id,
                quantity
            }));
        });
        if (!data.length) {
            return;
        }
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                items: data
            },
            dataType: 'json',
            success: (responseText)=>{
                const cart = typeof responseText === 'string' ? JSON.parse(responseText) : responseText;
                // Find the main item (the one with quantity: 1)
                const mainItem = data.find((item)=>item.quantity >= 1);
                let matchedCartItem = null;
                if (mainItem) {
                    // Match it in the cart
                    matchedCartItem = cart.items.find((cartItem)=>cartItem.variant_id === mainItem.id);
                }
                const eventSource = isCartPage ? 'cart_page' : 'mini_cart';
                if (matchedCartItem) {
                    var _matchedCartItem_product_type;
                    Shopify.analytics.publish('add_to_cart', {
                        event: 'Add to Cart',
                        productsToAdd: [
                            {
                                sku: matchedCartItem.sku,
                                name: matchedCartItem.product_title,
                                variantName: matchedCartItem.variant_title,
                                price: matchedCartItem.price,
                                quantity: matchedCartItem.quantity,
                                productType: (_matchedCartItem_product_type = matchedCartItem.product_type) !== null && _matchedCartItem_product_type !== void 0 ? _matchedCartItem_product_type : 'Unknown'
                            }
                        ],
                        source: eventSource
                    });
                }
                if (isCartPage) {
                    window.location.reload();
                    return;
                } else {
                    sendCartDrawerOpenRequestEvent();
                }
            }
        });
        refreshATCButton();
    });
    $(document).on('click', '.js-gift-cart-trigger, .js-offcanvas-trigger-gift', ()=>{
        $('.js-gift-cart').removeClass('u-hide');
        $('.js-gift-cart-trigger').addClass('u-hide');
        $('.js-offcanvas-trigger-gift').attr('aria-expanded', 'true');
        $('.js-gift-cart-trigger').attr('aria-expanded', 'true');
    });
    $(document).on('click', '.js-gift-cart-close, .js-offcanvas-close-gift', ()=>{
        $('.js-gift-cart').addClass('u-hide');
        $('.js-gift-cart-trigger').removeClass('u-hide');
        $('.js-offcanvas-trigger-gift').attr('aria-expanded', 'false');
        $('.js-gift-cart-trigger').attr('aria-expanded', 'false');
    });
    $(document).on('click', '.js-offcanvas-trigger-gift, .js-gift-cart-trigger', ()=>{
        var _cart_state_contents;
        const cart = getCartMachine();
        const cartItems = (_cart_state_contents = cart.state.contents) === null || _cart_state_contents === void 0 ? void 0 : _cart_state_contents.items;
        const giftBoxItems = $('.js-upsell-color-item');
        giftBoxItems.removeClass('u-vhide');
        if ((cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) && giftBoxItems.length) {
            giftBoxItems.each((i, item)=>{
                const ids = [];
                let alreadyIncludedInCart = 0;
                $(item).find('.js-upsell-price[variant_id]').each((_, variant)=>{
                    ids.push($(variant).attr('variant_id') || '');
                });
                $(item).find('.js-upsell-quantity').val(0);
                $(item).find('.js-upsell-quantity-number').text('0');
                $(item).find('.js-upsell-color[variant_id]').removeClass('u-vhide');
                cartItems.forEach((cartItem)=>{
                    if (ids === null || ids === void 0 ? void 0 : ids.includes(cartItem.variant_id.toString())) {
                        $(item).find(`.js-upsell-color[variant_id='${cartItem.variant_id}']`).addClass('u-vhide');
                        alreadyIncludedInCart++;
                        return;
                    }
                });
                $(item).find('.js-upsell-color:not(.u-vhide)').first().trigger('click');
                if (alreadyIncludedInCart === (ids === null || ids === void 0 ? void 0 : ids.length)) {
                    $(item).addClass('u-vhide');
                }
            });
        }
    });
};
